export interface PageTitleConfig {
  title: string;
  description?: string;
}

export const ROUTE_TITLES: Record<string, PageTitleConfig> = {
  '/': {
    title: 'Home',
    description: 'Your games at a glance',
  },
  '/wanted': {
    title: 'Wanted',
    description: 'Games you want to add to your collection',
  },
  '/awaiting': {
    title: 'Awaiting Arrival',
    description: 'Games on their way to your collection',
  },
  '/lists': {
    title: 'Lists',
    description: 'Organize your games into custom lists',
  },
  '/analytics': {
    title: 'Analytics',
    description: 'Collection statistics and insights',
  },
  '/add': {
    title: 'Add Game',
    description: 'Add a new game to your collection',
  },
  '/add/wanted': {
    title: 'Add Wanted Game',
    description: 'Add a game to your wanted list',
  },
  '/add/pending': {
    title: 'Add Pending Game',
    description: "Add a game that's on its way",
  },
  '/edit': {
    title: 'Edit Game',
    description: 'Edit game details',
  },
  '/upload': {
    title: 'Smart Import',
    description: 'Import a collection spreadsheet',
  },
  '/logout': {
    title: 'Logging Out',
    description: 'Signing out of your account',
  },
};

export const getPageTitle = (pathname: string, dynamicData?: Record<string, string>): PageTitleConfig => {
  // Handle dynamic routes with parameters
  if (pathname.startsWith('/edit/')) {
    return {
      title: dynamicData?.gameName ? `Edit ${dynamicData.gameName}` : 'Edit Game',
      description: 'Edit game details',
    };
  }

  if (pathname.startsWith('/gamedb/') && pathname !== '/gamedb') {
    if (pathname.startsWith('/gamedb/company/')) {
      return {
        title: dynamicData?.companyName ? `${dynamicData.companyName} - Company` : 'Company Details',
        description: 'Game company information',
      };
    } else {
      return {
        title: dynamicData?.gameName ? dynamicData.gameName : 'Game Details',
        description: 'Game information and details',
      };
    }
  }

  if (pathname.startsWith('/lists/')) {
    return {
      title: dynamicData?.listName ? dynamicData.listName : 'List Details',
      description: 'Custom game list',
    };
  }

  // Handle exact matches
  const exactMatch = ROUTE_TITLES[pathname];
  if (exactMatch) {
    return exactMatch;
  }

  // Handle partial matches for base routes
  const baseRoute = pathname.split('/')[1];
  if (baseRoute && ROUTE_TITLES[`/${baseRoute}`]) {
    return ROUTE_TITLES[`/${baseRoute}`];
  }

  // Default fallback
  return {
    title: 'The Game Project',
    description: 'Your collection unboxed!',
  };
};

export const setDocumentTitle = (title: string, description?: string) => {
  const baseTitle = 'The Game Project';
  const fullTitle = description
    ? `${title} - ${baseTitle}`
    : title === baseTitle
      ? baseTitle
      : `${title} - ${baseTitle}`;
  document.title = fullTitle;
};

export const getBreadcrumbTitle = (pathname: string, dynamicData?: Record<string, string>): string => {
  const config = getPageTitle(pathname, dynamicData);
  return config.title;
};
